const getters = {
  bosumYears: state => {
    if (!state.serverTime) return 20
    return new Date(state.serverTime).getFullYear() - 2006
  }
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js